/**
 * The set of supported line items that can appear on an order
 */
export var LineItemType;
(function (LineItemType) {
    /**
     * Since FTRX-4295 we no longer refer to transcripts as 'certified transcripts' in code or interfaces.
     * We instead refer to just 'transcripts'. All remaining references in code are legacy, but still in use.
     */
    LineItemType["CertifiedTranscript"] = "certified transcript";
    LineItemType["Audio"] = "audio";
    LineItemType["RealTime"] = "real time";
})(LineItemType || (LineItemType = {}));
